// @flow
import api from 'common/services/api';
import DateRange from 'common/domain/DateRange';
import { MetricsMetadata } from 'statsradio/modules/metrics/domain/Metrics';

function buildHeaders(token: string) {
  return { Authorization: 'Bearer ' + token };
}

async function getMetricsMetadata(callSign: string, token: string, dateRange: DateRange) {
  const { from, to } = dateRange.toISO();

  const { data } = await api.get(`/statsradio/metrics/${callSign}/metadata`, { from, to }, { headers: buildHeaders(token) });
  return MetricsMetadata.parseJson(data);
}

export default {
  getMetricsMetadata,
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/services/MetricsApi.js